import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendDeviceProgressStepper from "./components/progressStepper/amendDeviceProgressStepper"
import TTRAttachments from "./formPages/attachments/attachments"
import CoreDeviceDetails from "./formPages/coreDeviceDetails/coreDeviceDetails"
import ReviewAndSubmit from "./formPages/reviewAndSubmit/reviewAndSubmit"
import TypeTestDetails from "./formPages/typeTestDetails/typeTestDetails"
import { AmendDeviceContext } from "./providers/baseProviders/amendDeviceProvider"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import MultiPageForm from "../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../surfaces/appCard"

const AmendDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendDeviceContext}>
            <CoreDeviceDetails context={AmendDeviceContext} />
            <TypeTestDetails context={AmendDeviceContext} />
            <TTRAttachments context={AmendDeviceContext} />
            <ReviewAndSubmit context={AmendDeviceContext} />
        </MultiPageForm>
    </Stack>
)

export default AmendDeviceForm
